export * as SimpleNumber from './SimpleNumber';

export type Type = number;

export function create(): Type {
	return 0;
}

export function ifNullOrZeroMakeOne(input: number | null | undefined | string): number {
	if (typeof input !== 'number') return 1;
	if (input <= 0) return 1;
	return input;
}

export function round(input: number, places: number): number {
	return Math.round(input * Math.pow(10, places)) / Math.pow(10, places);
}
